import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./painting.css"; // <-- NEW isolated stylesheet

function useLightNav(flag = true) {
  useEffect(() => {
    const el = document?.body;
    if (!el) return;
    if (flag) el.setAttribute("data-light-nav", "true");
    return () => el.removeAttribute("data-light-nav");
  }, [flag]);
}

export default function Painting(props) {
  useLightNav(true);

  const { painting, fetchPainting, match } = props;
  const id = match.params.id;

  const [selectedImage, setSelectedImage] = useState(null);
  const [mainURL, setMainURL] = useState(null);
  const [showingAlt, setShowingAlt] = useState(false); 
  // showingAlt=false → show framed hero
  // showingAlt=true  → show alt view (no frame)

  // scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // fetch painting if needed
  useEffect(() => {
    if (!painting || painting._id !== id) {
      fetchPainting(id);
    }
  }, [painting, id, fetchPainting]);

  // init local state once painting loads
  useEffect(() => {
    if (painting) {
      setSelectedImage(painting.imageURL);
      setMainURL(painting.imageURL);
      setShowingAlt(false);
    }
  }, [painting]);

  // thumbnail click
  function selectImage(imgUrl) {
    if (!imgUrl) return;
    // clicked an alternate image:
    if (imgUrl !== selectedImage && imgUrl !== mainURL) {
      setSelectedImage(imgUrl);
      setShowingAlt(true);
    } else if (imgUrl === mainURL && imgUrl !== selectedImage) {
      // clicked the hero thumb to go back to framed hero
      setSelectedImage(imgUrl);
      setShowingAlt(false);
    }
  }

  const formattedPrice = (p) => {
    if (!p) return "Inquire For Price";
    const num = parseInt(String(p), 10);
    if (Number.isNaN(num)) return "Inquire For Price";
    return `$${num}`;
  };

  return (
    <div className="pd-shell fade-in">
      <div className="pd-page pad-top-50 fade-in">
        <Link to="/shop/paintings">
          <div className="pd-back-btn ">Back to Paintings</div>
        </Link>

        {painting ? (
          <div className="pd-flex-wrap">
            {/* LEFT COLUMN: main image + thumbs */}
            <div className="pd-left-col">
              {showingAlt ? (
                // ALT view, no frame
                <div className="pd-plain-wrap">
                  <img
                    className="pd-img-plain"
                    src={selectedImage}
                    alt={painting.title || ""}
                  />
                </div>
              ) : (
                // HERO view, framed
                <div className="pd-frame">
                  <img
                    className="pd-img-main"
                    src={selectedImage}
                    alt={painting.title || ""}
                  />
                </div>
              )}

              {/* thumbnail strip */}
              <div className="pd-thumb-row">
                {painting.image1 && painting.image1 !== selectedImage ? (
                  <img
                    onClick={() => selectImage(painting.image1)}
                    className="pd-thumb"
                    src={painting.image1}
                    alt=""
                  />
                ) : null}

                {painting.image2 && painting.image2 !== selectedImage ? (
                  <img
                    onClick={() => selectImage(painting.image2)}
                    className="pd-thumb"
                    src={painting.image2}
                    alt=""
                  />
                ) : null}

                {painting.image3 && painting.image3 !== selectedImage ? (
                  <img
                    onClick={() => selectImage(painting.image3)}
                    className="pd-thumb"
                    src={painting.image3}
                    alt=""
                  />
                ) : null}

                {painting.image4 && painting.image4 !== selectedImage ? (
                  <img
                    onClick={() => selectImage(painting.image4)}
                    className="pd-thumb"
                    src={painting.image4}
                    alt=""
                  />
                ) : null}

                {painting.image5 && painting.image5 !== selectedImage ? (
                  <img
                    onClick={() => selectImage(painting.image5)}
                    className="pd-thumb"
                    src={painting.image5}
                    alt=""
                  />
                ) : null}

                {painting.image6 && painting.image6 !== selectedImage ? (
                  <img
                    onClick={() => selectImage(painting.image6)}
                    className="pd-thumb"
                    src={painting.image6}
                    alt=""
                  />
                ) : null}

                {/* if we're viewing an alt image, also render the hero as a thumb so you can go back */}
                {showingAlt ? (
                  <img
                    className="pd-thumb"
                    onClick={() => selectImage(mainURL)}
                    src={mainURL}
                    alt=""
                  />
                ) : null}
              </div>
            </div>

            {/* RIGHT COLUMN: meta + CTA */}
            <div className="pd-right-col">
              <div className="pd-meta-block">
                {painting.series ? (
                  <div className="pd-meta-series">
                    From the Series:{" "}
                    <span className="pd-meta-series-name">
                      {painting.series}
                    </span>
                  </div>
                ) : null}

                {painting.title ? (
                  <div className="pd-meta-title">{painting.title}</div>
                ) : null}

                {painting.size ? (
                  <div className="pd-meta-size">{painting.size}</div>
                ) : null}

                <div className="pd-meta-price">
                  {painting.price
                    ? formattedPrice(painting.price)
                    : "Inquire For Price"}
                </div>
              </div>

              <a
                className="pd-inquire-btn"
                href={`mailto:contact@lorranlima.com?subject=Hi! I'm interested in this piece ID ${painting._id} &body=Please tell me more about this piece.`}
              >
                Inquire About This Piece
              </a>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
